import { render, staticRenderFns } from "./quotation.vue?vue&type=template&id=01f252e9"
import script from "./quotation.vue?vue&type=script&lang=js"
export * from "./quotation.vue?vue&type=script&lang=js"
import style0 from "./quotation.vue?vue&type=style&index=0&id=01f252e9&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f252e9')) {
      api.createRecord('01f252e9', component.options)
    } else {
      api.reload('01f252e9', component.options)
    }
    module.hot.accept("./quotation.vue?vue&type=template&id=01f252e9", function () {
      api.rerender('01f252e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/quotation.vue"
export default component.exports